import React from "react";
import { Card, ListGroup } from "react-bootstrap";
import { services } from "../data/services";

const HGSServices = () => {
  return (
    <div class="d-flex flex-wrap justify-space-around items-stretch">
      {services.map((service) => (
        <Card
          key={`service${service.id}`}
          style={{ margin: "10px", width: "18rem" }}
        >
          <Card.Header>{service.name}</Card.Header>
          <Card.Body>
          {!service.items && <div>{service.price}</div> }
            {service.items && service.items.length && (
              <ListGroup>
                {service.items.map((item) => (
                  <ListGroup.Item key={`item${item.id}`} className="d-flex justify-content-between">
                    <div>{item.name}</div>
                    <div>{item.price}</div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default HGSServices;
